import type {Module} from 'vuex'
import type {MymachineState} from './initial-state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import initialState from './initial-state'

const mymachine: Module<MymachineState, any> = {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters
}

export default mymachine
